import script from "./EditPortfolio.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditPortfolio.vue?vue&type=script&setup=true&lang=ts"

import "./EditPortfolio.vue?vue&type=style&index=0&id=45568f96&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45568f96"]])

export default __exports__